var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "NodeViewWrapper",
    { ref: "customTagsAndFieldsTrigger", attrs: { as: "span" } },
    [
      _c(
        "span",
        {
          class: _vm.classes,
          attrs: {
            tag: _vm.tag,
            draggable: _vm.isDraggable,
            "data-drag-handle": ""
          },
          on: {
            mouseover: _vm.handleMouseOver,
            mouseleave: _vm.handleMouseLeave,
            focus: _vm.handleFocus,
            blur: _vm.handleBlur
          }
        },
        [
          _vm.showDragIcon
            ? _c("CompassIcon", {
                attrs: { icon: "ai-drag-plan", size: "extra-small" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "typographies-paragraph-small-semibold" }, [
            _vm._v("\n            " + _vm._s(_vm.label) + "\n        ")
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }